// stores/alertStore.ts
import type { ReactNode } from "react";
import { create } from "zustand";

type AlertVariant =
	| "info"
	| "success"
	| "warning"
	| "secondary"
	| "primary"
	| "destructive"
	| "mono"
	| null
	| undefined;

interface AlertState {
	title: string;
	description?: string | ReactNode;
	variant: AlertVariant;
	visible: boolean;

	// actions
	showAlert: (data: {
		title: string;
		description?: string | ReactNode;
		variant?: AlertVariant;
	}) => void;
	hideAlert: () => void;
	resetAlert: () => void;
}

export const useAlertStore = create<AlertState>((set) => ({
	title: "",
	variant: "info",
	visible: false,

	showAlert: ({ title, description, variant }) =>
		set({
			title,
			description,
			variant,
			visible: true,
		}),

	hideAlert: () =>
		set({
			visible: false,
		}),

	resetAlert: () =>
		set({
			title: "",
			variant: "info",
			visible: false,
		}),
}));
